import apiClient, { requiresAuth } from "./apiClient";

class UserManagementService {
  async fetchUsers() {
    try {
      const response = await apiClient.get("/users", requiresAuth());
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  }

  async addUser(userData: any) {
    try {
      const response = await apiClient.post("/users", userData, requiresAuth());
      return response.data;
    } catch (error) {
      console.error("Error adding user:", error);
      throw error;
    }
  }

  async archiveUser(userId: number) {
    try {
      await apiClient.delete(`/users/${userId}`, requiresAuth());
    } catch (error) {
      console.error("Error archiving user:", error);
      throw error;
    }
  }

  async restoreUser(userId: number) {
    try {
      await apiClient.post(`/users/${userId}/restore`, null, requiresAuth());
    } catch (error) {
      console.error("Error restoring user:", error);
      throw error;
    }
  }

  async updateUser(userId: number, userData: any) {
    try {
      const response = await apiClient.put(
        `/users/${userId}`,
        userData,
        requiresAuth()
      );
      return response.data;
    } catch (error) {
      console.error("Error updating user:", error);
      throw error;
    }
  }

  async initiatePasswordReset(email: string) {
    try {
      const response = await apiClient.post(
        `/users/initiate-password-reset`,
        { email },
        requiresAuth()
      );
      return response.data;
    } catch (error) {
      console.error("Error initiating password reset:", error);
      throw error;
    }
  }

  async resendInvitation(userId: number) {
    try {
      await apiClient.post(
        `/users/${userId}/resend-invitation`,
        null,
        requiresAuth()
      );
    } catch (error) {
      console.error("Error resending invitation:", error);
      throw error;
    }
  }

  async changePassword(
    userId: number,
    currentPassword: string,
    newPassword: string
  ) {
    try {
      await apiClient.post(
        `/users/${userId}/setPassword`,
        {
          currentPassword,
          newPassword,
        },
        requiresAuth()
      );
    } catch (error) {
      console.error("Error changing password:", error);
      throw error;
    }
  }

  async setInitialPassword(token: string, password: string, lastName: string) {
    try {
      await apiClient.post(
        `/users/set-initial-password`,
        { token, password, lastName },
        requiresAuth()
      );
    } catch (error) {
      console.error("Error setting initial password:", error);
      throw error;
    }
  }

  async resetPassword(token: string, password: string) {
    try {
      await apiClient.post(
        `/users/reset-password`,
        { token, password },
        requiresAuth()
      );
    } catch (error) {
      console.error("Error resetting password:", error);
      throw error;
    }
  }
}

export default new UserManagementService();
